<!--
/**
 * APCWO customisation for OrangeHRM — Email Templates module.
 *
 * Licensed under the GNU General Public License v2.0 or later, the same terms
 * as OrangeHRM itself. See the LICENSE file at the project root.
 */
-->

<template>
  <div class="orangehrm-background-container">
    <div class="orangehrm-card-container">
      <oxd-text tag="h6" class="orangehrm-main-title">
        Add Email Template
      </oxd-text>
      <oxd-divider />
      <email-template-form
        :loading="isLoading"
        :body-error="bodyError"
        submit-label="Save"
        @submit="onSave"
        @cancel="onCancel"
      />
    </div>
  </div>
</template>

<script>
import {navigate} from '@ohrm/core/util/helper/navigation';
import {APIService} from '@ohrm/core/util/services/api.service';
import EmailTemplateForm from '../components/EmailTemplateForm.vue';

export default {
  name: 'SaveEmailTemplate',
  components: {
    'email-template-form': EmailTemplateForm,
  },
  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/apcwo/email-templates',
    );
    return {http};
  },
  data() {
    return {
      isLoading: false,
      bodyError: null,
    };
  },
  methods: {
    onSave(payload) {
      this.isLoading = true;
      this.bodyError = null;
      this.http
        .create(payload)
        .then(() => this.$toast.saveSuccess())
        .then(() => this.onCancel())
        .catch((e) => {
          const message = e?.response?.data?.error?.message;
          if (message) {
            this.bodyError = message;
            this.$toast.error({title: 'Error', message});
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onCancel() {
      navigate('/admin/viewEmailTemplates');
    },
  },
};
</script>
